import { Component } from 'react'
// import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'
import { connect } from 'react-redux'

import Auth from '../Auth'
import Queues from '../Queues'
import Tills from '../Tills'
import Displays from '../Displays'
import Header from '../../components/Header'
import Footer from '../../components/Footer'
import { WhiteLayout, PaddedContent } from '../../common/styled'

class App extends Component {
  static propTypes = {}

  render() {
    const { user } = this.props
    return (
      <WhiteLayout>
        <Header user={user} />
        <Auth>
          <PaddedContent>
            <Switch>
              <Route component={Queues} exact path={'/'} />
              <Route component={Tills} exact path={'/tills'} />
              <Route component={Displays} exact path={'/displays'} />
            </Switch>
          </PaddedContent>
        </Auth>
        <Footer />
      </WhiteLayout>
    )
  }
}
const mapStateToProps = state => ({
  user: state.user.current
})
export default connect(mapStateToProps)(App)
